import { useCallback } from 'react';
import AIBasePopover from 'components/AIBasePopover';
import AIFindingBody from 'components/AIBasePopover/AIFindingBody';
import CitationBody from 'components/AIBasePopover/CitationBody';
import { AISecurityFindingPopoverProps } from './AISecurityFindingPopover.props';
import GradientDivider from '../../../../Documents/components/SuggestedDocumentReference/GradientDivider';

const AISecurityFindingPopover = ({
  fieldMetadata,
  accuracyConfidence,
  fieldLabel,
  onAccept,
  onRemove,
  openOnClick = false,
  pendingCitation,
  onAcceptCitation,
  pendingCitationDocumentName,
  children,
}: AISecurityFindingPopoverProps) => {
  const overallConfidence = accuracyConfidence ? parseFloat(accuracyConfidence) : null;
  const commentary = fieldMetadata.commentary ?? [];

  const pendingConfidence = pendingCitation?.tokenReferences?.[0]?.confidence;
  const pendingPlainTexts =
    pendingCitation?.tokenReferences?.map(t => t.plain_text).filter(Boolean) ?? [];

  const handleAccept = useCallback(() => {
    onAccept?.();
    if (pendingCitation && onAcceptCitation) {
      onAcceptCitation();
    }
  }, [onAccept, onAcceptCitation, pendingCitation]);

  const expandedBody = (
    <>
      <AIFindingBody
        confidence={fieldMetadata.confidence}
        overallConfidence={overallConfidence}
        commentary={commentary}
      />
      {pendingCitation && (
        <>
          <GradientDivider />
          <CitationBody
            sectionLabel="Citation"
            confidence={pendingConfidence}
            plainTexts={pendingPlainTexts}
            documentName={pendingCitationDocumentName}
          />
        </>
      )}
    </>
  );

  return (
    <AIBasePopover
      title="AI Finding"
      subtitle={fieldLabel}
      acceptLabel="Accept"
      declineLabel="Dismiss"
      onAccept={onAccept || onRemove ? handleAccept : undefined}
      onDecline={onRemove ?? undefined}
      expandedBody={expandedBody}
      trigger="click">
      {({ onClick }) => children({ onClick })}
    </AIBasePopover>
  );
};

export default AISecurityFindingPopover;
